import React from "react";
import Header from "../Components/Header.jsx";
import PointcloudNavigator from "../Components/PointcloudNavigator.jsx";
import ButtonCallback from "../Components/ButtonCallback.jsx";

import { navigate } from "@reach/router"

import "./Explore.css";

const Explore = ({ hall, location}) => {
  function post3d(e) {
    e.preventDefault();
    
    const { x, y, z } = window.scene.view.position;
    hall = hall || "2w";

    navigate(`/gallery?x=${x}&y=${y}&z=${z}&hall=${hall}`);
  }

  console.log("hall in explore:", hall);
  return (
    <div className="h-100">
      <PointcloudNavigator hallfromexplore={hall} location={location}/>
      <Header />
      <div class="fixed bottom-0 left-0 right-0 text-center p-8 select-none">
        <ButtonCallback onClick={post3d} text="❤️‍🔥 Click To Add Post Here ( in 3D!! ) ❤️‍🔥" className="border-2 border-red-500 text-red-500 shadow-lg font-black pulse-border" to="/gallery?x=todo" />
      </div>
    </div>
  );
};

export default Explore;
